module.exports = __webpack_public_path__ + "img/NL578.7c6e62a8.png";